// extracted by mini-css-extract-plugin
module.exports = {"howItWorks":"ReserveNowHowItWorks_howItWorks__05AgS"};